import { render, staticRenderFns } from "./MultipleQuestion.vue?vue&type=template&id=daad76ba"
import script from "./MultipleQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleQuestion.vue?vue&type=script&lang=js"
import style0 from "./MultipleQuestion.vue?vue&type=style&index=0&id=daad76ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports